import { render, staticRenderFns } from "./ServiceComponent.vue?vue&type=template&id=37bcd2c2&"
import script from "./ServiceComponent.vue?vue&type=script&lang=js&"
export * from "./ServiceComponent.vue?vue&type=script&lang=js&"
import style0 from "./ServiceComponent.vue?vue&type=style&index=0&id=37bcd2c2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports